<template>
  <article class="tile is-child box" v-if="service && parseInt(service.dispute_v2) !== 0 && (disputes && disputes.length > 0)">
    <h4 class="title">Dispute V2</h4>
    <div class="columns is-multiline">
      <div class="column is-12" v-if="disputes != null && disputes != ''">
        <div class="card is-fullwidth" style="box-shadow: 0 2px 3px #A71C20, 0 0 0 1px #A71C20;">
          <header class="card-header is-primary" style="box-shadow: 0 1px 0px #A71C20, 0 0 0 0px #A71C20; background-color: #A71C20;">
            <p class="card-header-title is-primary" style="color: #FFFFFF;">Dispute for: {{ this.disputeType(service.dispute_type_v2) }}</p>
          </header>
          <div class="card-content">
            <div class="content">
              <article class="media">
                <p>
                  <b>Status:</b> {{ service.dispute_status_v2 == 1 ? 'Open' : 'Closed' }}<br/>
                  <b>Type:</b> {{ this.disputeType(service.dispute_type_v2) }}<br/>
                </p>
              </article>
              <article class="media">
                <pre>{{ disputes[0].dispute}}</pre>
              </article>
              <p>
                <small class="is-pulled-right"><b>{{ disputes[0].user.name }}</b> at <b>{{ disputes[0].created_at }}</b></small>
              </p>
            </div>
          </div>
        </div>
      </div>
      <template v-for="dispute in disputes">
          <div class="column is-12" v-if="dispute.status != 1">
            <div class="card is-fullwidth">
              <div class="card-content">
                <div class="content">
                  <pre>{{ dispute.dispute }}</pre>
                  <p>
                    <small class="is-pulled-right"><b>{{ dispute.user.name }}</b> at <b>{{ dispute.created_at }}</b>
                    </small>
                  </p>
                </div>
              </div>
            </div>
          </div>
      </template>
      <div class="column is-12" v-if="parseInt($store.state.config.user.level) < 99 && service.dispute_status_v2 < 2">
        <div class="card is-fullwidth">
          <header class="card-header">
            <p class="card-header-title is-primary">{{ service.dispute_v2 == 0 ? 'Open Dispute' : 'Dispute' }}</p>
          </header>
          <div class="card-content">
            <div class="notification is-danger" v-if="error !== ''">{{ error }}</div>
            <div class="content">
              <div class="control is-vertical">
                <div class="control">
                  <textarea :class="{'textarea': true, 'is-danger': errors.has('message') }" name="message" id="message" placeholder="" v-model="dispute.message" v-validate data-vv-rules="required"></textarea>
                  <span v-show="errors.has('message')" class="help is-danger">{{ errors.first('message') }}</span>
                </div>
              </div>
              <p>
                <div class="is-clearfix" v-if="service.dispute_status_v2 == 1">
                  <div class="is-clearfix" v-if="service.dispute !== 0"></div>
                  <div class="control is-grouped">
                    <p class="control">
                      <label class="label">Close To</label>
                      <select style="margin-right: 10px;" class="select is-pulled-right" v-model="dispute.type">
                        <option v-if="service.dispute_type_v2 === 3" value="3">ALL</option>
                        <option v-if="service.dispute_type_v2 === 1" value="1">CUSTOMER</option>
                        <option v-if="service.dispute_type_v2 === 2" value="2">SUPPLIER</option>
                      </select>
                    </p>
                    <p class="control">
                      <label class="label">Close Option</label>
                      <select style="margin-right: 10px;" class="select" v-model="dispute.close_option" ref="close_option">
                        <option value="0">FULL CHARGE</option>
                        <!-- <option value="1">PARTIAL</option> -->
                        <option value="2">FREE CHARGES</option>
                      </select>
                    </p>
                    <p class="control" v-if="parseInt(dispute.close_option) === 1">
                      <label class="label">Provider Price</label>
                      <input :class="{'input': true, 'is-danger': errors.has('provider_price'), 'is-disabled': parseInt(dispute.close_option) !== 1}" name="provider_price" id="provider_price" type="text" placeholder="" v-model="dispute.provider_price" v-validate="`required|decimal|max_value:${service.room.provider_price}|min_value:1`">
                      <span v-show="errors.has('provider_price')" class="help is-danger">{{ errors.first('provider_price') }}</span>
                    </p>
                    <a style="margin-top: 25px;" :class="{'button': true, 'is-primary': true, 'is-disabled': errors.any() || inProgress, 'is-loading': inProgress}" @click="closeDispute">Close Dispute</a>
                  </div>
                  <a style="margin-top: -42px;" :class="{'button': true, 'is-warning': true, 'is-pulled-right': true, 'is-loading': inProgress, 'is-disabled': errors.any() || inProgress}" @click="replyDispute">Save</a>
                </div>
                </div>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </article>
</template>

<script>
  import message from '../../../utils/message'
  export default {
    props: {
      service: {
        type: Object
      }
    },
    data () {
      return {
        dispute: {
          message: '',
          type: this.service.dispute_type_v2,
          close_option: 0,
          provider_price: 0,
          dispute_main: null
        },
        disputes: null,
        inProgress: false,
        error: ''
      }
    },
    mounted () {
      this.$nextTick(() => {
        this.loadData()
      })
    },
    methods: {
      setProviderPrice () {
        // if (parseInt(this.dispute.close_option) === 1) {
        //   this.$validator.attach('provider_price', `required|decimal|max_value:${this.service.room.provider_price}|min_value:1`)
        // }
      },
      openDispute () {
        if (window.confirm('Are you sure you want to open dispute?')) {
          this.$validator.validateAll().then(() => {
            if (this.errors.items.length === 0) {
              this.$http.post(this.$store.state.config.apiURL + '/V2/dispute', this.dispute).then((response) => {
                if (response.body.hasOwnProperty('error')) {
                  this.error = response.body.description
                } else {
                  window.location.reload()
                  this.loadData()
                  this.dispute.message = ''
                  this.error = ''
                }
              }, (response) => {
                this.message('danger', 'Error', response.body)
              })
            }
          })
        }
      },
      disputeType (data) {
        if (parseInt(data) === 3) {
          return 'ALL'
        } else if (parseInt(data) === 1) {
          return 'Customer'
        }
        return 'Supplier'
      },
      replyDispute () {
        this.$validator.validateAll().then(() => {
          if (this.errors.items.length === 0) {
            this.$http.post(this.$store.state.config.apiURL + '/V2/dispute/' + this.service.id + '/reply', this.dispute).then((response) => {
              this.loadData()
              window.location.reload()
              this.dispute.message = ''
              this.$validator.reset()
            }, (response) => {
              this.message('danger', 'Error', response.body)
            })
          }
        }).catch(() => {
        })
      },
      closeDispute () {
        this.$validator.validateAll().then(() => {
          if (this.errors.items.length === 0) {
            this.dispute.type = parseInt(this.dispute.type)
            this.dispute.close_option = parseInt(this.dispute.close_option)
            this.$http.post(this.$store.state.config.apiURL + '/V2/dispute/' + this.service.id + '/close', this.dispute).then((response) => {
              this.loadData()
              window.location.reload()
              this.message('success', 'Success', 'The dispute was successfully close')
              this.dispute.message = ''
            }, (response) => {
              this.message('danger', 'Error', response.body)
            })
          } else {
          }
        }).catch(() => {
        })
      },
      loadData () {
        this.dispute.service_id = this.service.id
        this.dispute.provider_price = this.service.room.provider_price
        this.$http.get(this.$store.state.config.apiURL + '/V2/dispute/service/' + this.service.id).then((response) => {
          this.disputes = response.body
          this.dispute.dispute_main = this.disputes[0].id
        }, (response) => {
          let propsData = {
            title: 'Error',
            message: response.body,
            type: 'danger',
            direction: 'down',
            duration: 4500,
            showCloseButton: true
          }
          message.openMessage(propsData)
        })
      },
      message (type, title, content) {
        let propsData = {
          title: title,
          message: content,
          type: type,
          direction: 'down',
          duration: 4500,
          showCloseButton: true
        }
        message.openMessage(propsData)
      }
    },
    watch: {
      reload () {
        if (this.reload) {
          this.loadData()
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  pre {
    background-color: #FFFFFF;
    white-space: -moz-pre-wrap; /* Mozilla, supported since 1999 */
    white-space: -pre-wrap; /* Opera */
    white-space: -o-pre-wrap; /* Opera */
    white-space: pre-wrap; /* CSS3 - Text module (Candidate Recommendation) http://www.w3.org/TR/css3-text/#white-space */
    word-wrap: break-word; /* IE 5.5+ */
    font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, Helvetica, Arial, sans-serif;
    color: #4a4a4a;
    font-size: 1rem;
    font-weight: 400;
  }
</style>



// WEBPACK FOOTER //
// Dispute.vue?536c33c8